/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// window.PDFJS_LOCALE = {
//     pdfJsWorker: 'https://cdn.shopify.com/s/files/1/0669/3945/3762/t/2/assets/pdf.worker.js?v=137858186632778794021673953690',
//     pdfJsCMapUrl: 'cmaps'
//   };


      // $('#flipbook').FlipBook({
      //   pdf: 'https://cdn.shopify.com/s/files/1/0669/3945/3762/files/FoxitPdfSdk.pdf',
      //   template: {
      //     html: 'https://cdn.shopify.com/s/files/1/0850/6410/t/73/assets/default-book-view.html',
      //     styles: [
      //       'https://cdn.shopify.com/s/files/1/0669/3945/3762/t/2/assets/short-black-book-view.css'
      //     ],
      //     links: [
      //       {
      //         rel: 'stylesheet',
      //         href: 'https://cdn.shopify.com/s/files/1/0669/3945/3762/t/2/assets/font-awesome.min.css'
      //       }
      //     ],
      //     script: 'https://cdn.shopify.com/s/files/1/0669/3945/3762/t/2/assets/default-book-view.js'
      //   }
      // });

      // $('#flipbook').FlipBook({
      //   pdf: 'https://cdn.shopify.com/s/files/1/0669/3945/3762/files/FoxitPdfSdk.pdf',
      //   template: {
      //     html: 'https://cdn.shopify.com/s/files/1/0850/6410/t/73/assets/default-book-view.html',
      //     styles: [
      //       'https://cdn.shopify.com/s/files/1/0669/3945/3762/t/2/assets/short-black-book-view.css?v=17160967184722894171673862432'
      //     ],
      //     links: [
      //       {
      //         rel: 'stylesheet',
      //         href: 'https://cdn.shopify.com/s/files/1/0669/3945/3762/t/2/assets/font-awesome.min.css?v=78707615589518789421673938185'
      //       }
      //     ],
      //     script: 'https://cdn.shopify.com/s/files/1/0669/3945/3762/t/2/assets/default-book-view.js?v=84402549217226129501673862378'
      //   }
      // });

  // $('.tab-nav li a').on('click', function(){
		//    	var target = $(this).attr('data-rel');
		// 	$('.tab-nav li a').removeClass('active');
		//    	$(this).addClass('active');
		//    	$("#"+target).fadeIn('slow').siblings(".tab-box").hide();
		//    	return false;
  // });

$('.pairing-sidebar .category h2').click(function(){
  $(this).toggleClass('active', 500);
  $(this).next('ul').toggle(500);
  
})


 function sucss(t) {


 document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 bubbles: true
 }));
 
      $('.PageOverlay').addClass('is-visible');
      $('html').addClass('no-scroll');
     document.getElementById('sidebar-cart').setAttribute("aria-hidden", "false");
      document.getElementById('sidebar-cart').setAttribute("tabindex", "-1");
                     $('.Drawer__Close').click(function() {
         $('html').removeClass('no-scroll');
         $('.PageOverlay').removeClass('is-visible');
  document.getElementById('sidebar-cart').setAttribute("aria-hidden", "true");
       });
       $('.PageOverlay').click(function() {
         $('html').removeClass('no-scroll');
          $('.PageOverlay').removeClass('is-visible');
  document.getElementById('sidebar-cart').setAttribute("aria-hidden", "true");
       });
  }
  $(document).on('click', '.add_to_c', function(t){
   
        addItem($(this).parents("form").attr("id"));
         
      });
        $(document).on('click', '.add_to_cd', function(t){
   event.preventDefault(t);
        addItem($(this).parents("form").attr("id"));
         
      });
    
    function addItem(t) {
      $.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: $("#" + t).serialize(), success: Shopify.onSuccess, error: Shopify.onError });
    }

  (Shopify.onSuccess = function () {
      $("#AddToCart").removeAttr("disabled");
      $("#button2").removeAttr("disabled");
      parseInt(jQuery('[name="quantity"]').val(), 10);
      $.ajax({
        type: "GET",
        url: "/cart",
        dataType: "html",
        success: function (t) {

          sucss(t);
        },
      });
    }),
      (Shopify.onError = function (XMLHttpRequest, textStatus) {
      console.log("errorerror");
      var data = eval("(" + XMLHttpRequest.responseText + ")");
      data.message ? alert(data.message + "(" + data.status + "): " + data.description) : alert("Error : " + Shopify.fullMessagesFromErrors(data).join("; ") + "."), $(".addtocart").removeAttr("disabled");
    }),
      (Shopify.fullMessagesFromErrors = function (t) {
      var n = [];
      return (
        jQuery.each(t, function (i, t) {
          jQuery.each(t, function (t, e) {
            n.push(i + " " + e);
          });
        }),
        n
      );
    });

$('.moreless-button').click(function() {
  $('.more-text').toggleClass('more', 500);
  if ($('.moreless-button').text() == "Read More") {
    $(this).text("Read less")
  } else {
    $(this).text("Read More")
  }
});


if ( window.location.href.includes('the-catalogue-volume-01') ) {
  window.location.href = "/pages/book"
}


var scrolled = false;

function stickNav() {
  if ( window.scrollY == 0 ) {
    $('body').removeClass('scrolled')
    scrolled = false
  } else if ( !scrolled ) {
      $('body').addClass('scrolled')
      var scrolled = true
  }
}
$(document).on('scroll', function() {
  stickNav()
})
stickNav()

$(document).ready( function() {  
  document.querySelectorAll(".flipbook-container").forEach(function (el) {
    // $(el).turn({
    //   width: 600,
    //   height: 400,
    //   autoCenter: true
    // });
  });

  var $html = $('.MegaMenu:first').clone().addClass('mobile-mega')
  $html.find('.MegaMenu__Inner').prepend(`<a href="#" class="Collapsible__Button Heading Link Link--primary u-h6 mobile-mega-back"><?xml version="1.0" encoding="iso-8859-1"?>
<svg height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 185.343 185.343" xml:space="preserve">
<g>
	<g>
		<path style="fill:#010002;" d="M51.707,185.343c-2.741,0-5.493-1.044-7.593-3.149c-4.194-4.194-4.194-10.981,0-15.175
			l74.352-74.347L44.114,18.32c-4.194-4.194-4.194-10.987,0-15.175c4.194-4.194,10.987-4.194,15.18,0l81.934,81.934
			c4.194,4.194,4.194,10.987,0,15.175l-81.934,81.939C57.201,184.293,54.454,185.343,51.707,185.343z"/>
	</g>
</g>
</svg>Shop All</a>`)
  console.log( $html.find('.MegaMenu__Inner') )
  $('.Drawer__Main').append($html)

  $('.SidebarMenu__Nav .Collapsible:first a').on('click', function() {
    event.preventDefault();
    $('.Drawer__Container').addClass('slide-left')
    $('.MegaMenu').addClass('slide-left')
  })

  $('.mobile-mega-back').on('click', function() {
    event.preventDefault();
    $('.Drawer__Container').removeClass('slide-left')
    $('.MegaMenu').removeClass('slide-left')
  })
})


$(document).on('click', '.Slideshow.Slideshow--fullscreen .ButtonGroup--sameSize .ButtonGroup__Item', function() {
  event.preventDefault();
  var $target = $($(this).attr('href'))
  console.log( $target )
  console.log( $target.offset )
  $('html, body').animate({
    scrollTop: $target.offset().top - 100 // Scroll to the top of the page
  }, 'slow'); 
})